import { RouteRecordRaw } from 'vue-router';
import * as CONST from '@/const'

let routes: RouteRecordRaw[] = [
    {
        path: '/shopCategories',
        name: 'shopCategories',
        component: () => import("./views/shopCategories.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.SuperAdmin]
        }
    },
    {
        path: '/shopCategories/:identifier',
        name: 'shopCategoryDetail',
        component: () => import("./views/shopCategoryDetail.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.SuperAdmin]
        }
    },
];

export default routes;
